// Section 8 and 11: Teacher. Teaches 6 students per fully productive worker (output, capped by
// the school's seats; the society phase seats floor(output) students with each teacher and caps
// what they learn at the teacher's own level, D-30); needs a school and skill 2+ in a subject
// (or literacy). Constants: config.jobs.teacher.
import type { Config } from '../../config';
import { defineJob, noModifiers } from '../../core/registry';

export function teacher(config: Config) {
  const c = config.jobs.teacher;

  return defineJob({
    id: 'teacher',
    label: 'Teacher',
    section: 'S8',
    heavy: false,
    output: { kind: 'service', service: 'teachingSeats' },
    baseYield: c.students,
    toolFactor: null,
    toolWear: 0,
    risks: {},
    riskIllness: null,
    requiresBuilding: 'school',
    minStrength: 0,
    modifierTargets: [],
    modifiers: noModifiers,
    produce: (_ctx, _worker, output) =>
      output > 0 ? [{ kind: 'service', service: 'teachingSeats', amount: output }] : [],
    eligible: (_ctx, person) =>
      person.status.literate || Object.values(person.skills).some((s) => s >= c.minSkill),
  });
}
